import { Injectable } from "@angular/core";

@Injectable()
export abstract class ListStatusTranslationService {
    public abstract getStatusTranslationsMap(hasSupervisorPermissions: boolean): Record<string, string>;
}
